import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  IconButton,
} from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const SortingFilter = ({
  sortOption,
  sortDirection,
  onSortChange,
  onDirectionChange,
}) => {
  return (
    <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
      <FormControl sx={{ minWidth: 200 }}>
        <InputLabel id="sort-select-label">Sortierung</InputLabel>
        <Select
          labelId="sort-select-label"
          id="sort-select"
          value={sortOption}
          label="Sortierung"
          onChange={(e) => onSortChange(e.target.value)}
        >
          <MenuItem value="number">Nach Trikotnummer</MenuItem>
          <MenuItem value="currentBid">Nach aktuellem Gebot</MenuItem>
          <MenuItem value="endTime">Nach Ablaufzeit</MenuItem>
        </Select>
      </FormControl>

      <IconButton
        onClick={() =>
          onDirectionChange(sortDirection === "asc" ? "desc" : "asc")
        }
        color="primary"
      >
        {sortDirection === "asc" ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
      </IconButton>
    </Box>
  );
};

export default SortingFilter;
